module.exports = __webpack_public_path__ + "img/2_Wir Vermissn VS 1 Saalfelden.291670bf.jpg";